<template>
  <!-- 授权用户 -->
  <el-dialog title="选择用户" :visible.sync="visible" width="800px" top="5vh" append-to-body>
    <el-form :model="queryParams" ref="queryForm" :inline="true">
      <el-form-item label="用户名称" prop="userName">
        <el-input
          v-model="queryParams.userName"
          placeholder="请输入用户名称"
          clearable
        />
      </el-form-item>
      <el-form-item label="手机号码" prop="phonenumber">
        <el-input
          v-model="queryParams.phonenumber"
          placeholder="请输入手机号码"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">搜 索</el-button>
        <el-button @click="resetQuery">重 置</el-button>
      </el-form-item>
    </el-form>
    <el-row>
      <el-table ref="table" :data="userList" @selection-change="handleSelectionChange" height="260px">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column label="序号" width="60" type="index" align="center"></el-table-column>
        <el-table-column label="用户名称" prop="userName"/>
        <el-table-column label="用户昵称" prop="nickName"/>
        <el-table-column label="邮箱" prop="email"/>
        <el-table-column label="手机" prop="phonenumber"/>
        <el-table-column label="状态" align="center" prop="status">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 0">正常</el-tag>
            <el-tag v-else-if="scope.row.status == 1" type="danger">停用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" prop="createTime" width="180">
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParams.pageSize"  
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSelectUserConfirm">确 定</el-button>
      <el-button @click="visible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { unAuthUserList, selectAuthUserAll } from "@/api/system/permission/role";
export default {
  name: "SelectUser",
  props: {
    // 角色编号
    roleId: {
      type: [Number, String]
    }
  },
  data() {
    return {
      // 是否显示
      visible: false,
      // 总条数
      total: 0,
      // 未授权用户数据
      userList: [],
      // 选中数组值
      userIds: [],
      // 查询参数
      queryParams: {
        roleId: null,
        userName: null,
        phonenumber: null,
        pageNum: 1,
        pageSize: 10,
      }
    };
  },
  methods: {
    // 显示弹框
    show() {
      this.queryParams.roleId = this.roleId;
      this.getList();
      this.visible = true;
    },
    // 查询表数据
    getList() {
      unAuthUserList(this.queryParams).then(res => {
        this.userList = res.rows;
        this.total = parseInt(res.total);
      });
    },
    // 搜索
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },

    // 多选框选中数据
    handleSelectionChange(selection) {
      this.userIds = selection.map(item => item.userId);
    },
    // 选择授权用户
    handleSelectUser() {
      const roleId = this.queryParams.roleId;
      const userIds = this.userIds.join(",");
      selectAuthUserAll({ roleId: roleId, userIds: userIds }).then(res => {
        this.$message({type: "success", message: "授权成功"});
  
        if (res.code === 200) {
          this.visible = false;
          this.$emit("ok");
        }
      });
    },
    handleSelectUserConfirm(){
       if(global.$config.app.project=="hongqifang"){
          this.$emit("confirm");
       }else{
        //不是红旗坊项目直接请求接口就行
        this.handleSelectUser()
       }
    },
    // 点击每页显示的条数
    handleSizeChange(val){
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 点击切换到某页
    handleCurrentChange(val){
      this.queryParams.pageNum = val;
      this.getList();
    }
  }
};
</script>